import {
  DeclaredUnit,
  IComponentDetails,
  ICrossSectoralStandardsUsedV2,
} from '../../interfaces/IComponentDetails';
import { IProduct } from '../../interfaces/IProduct';

export type ActivePcfViewModel = {
  id?: string | number;
  createdDate?: string;
  declaredUnit?: DeclaredUnit;
  unitaryProductAmount?: number;
  referencePeriodStart?: string;
  referencePeriodEnd?: string;
  crossSectoralStandards?: ICrossSectoralStandardsUsedV2[];
  pcfExcludingBiogenic?: number;
  pcfIncludingBiogenic?: number;
  pcfLegalStatement?: string;
};

export const mapProductToActivePcf = (product?: IProduct): ActivePcfViewModel => {
  return {
    id: product?.pcf?.activeCarbonFootprintId,
    createdDate: product?.pcf?.activeCarbonFootprintCreatedDate,
    declaredUnit: product?.pcf?.activeCarbonFootprintDeclaredUnit,
    unitaryProductAmount: product?.pcf?.activeCarbonFootprintUnitaryProductAmount,
    referencePeriodStart: product?.pcf?.activeCarbonFootprintReferencePeriodStart,
    referencePeriodEnd: product?.pcf?.activeCarbonFootprintReferencePeriodEnd,
    crossSectoralStandards: product?.pcf?.activeCarbonFootprintCrossSectoralStandardsUsed ?? [],
    pcfExcludingBiogenic: product?.pcf?.pcfExcludingBiogenic,
    pcfIncludingBiogenic: product?.pcf?.pcfIncludingBiogenic,
    pcfLegalStatement: product?.pcf?.activeCarbonFootprintPcfLegalStatement,
  };
};

export const mapComponentToActivePcf = (component?: IComponentDetails): ActivePcfViewModel => {
  return {
    id: component?.pcf?.id,
    createdDate: component?.created,
    declaredUnit: component?.pcf?.declaredUnit,
    unitaryProductAmount: component?.pcf?.unitaryProductAmount,
    referencePeriodStart: component?.pcf?.referencePeriodStart,
    referencePeriodEnd: component?.pcf?.referencePeriodEnd,
    crossSectoralStandards: component?.pcf?.crossSectoralStandardsUsed ?? [],
    pcfExcludingBiogenic: component?.pcf?.pcfExcludingBiogenic,
    pcfIncludingBiogenic: component?.pcf?.pcfIncludingBiogenic,
    pcfLegalStatement: component?.pcfLegalStatement,
  };
};
